import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { required } from '../../utils/validations'
import BasicForm from '../forms/BasicForm'

export default class UpdatePassword extends Component {
  render() {
    return (
      <BasicForm
        fields={ this.fields() }
        onSubmit={ this.onSubmit }
      />
    )
  }

  fields = () => {
    return [{
      name: 'password',
      placeholder: 'New Password',
      type: 'text',
      validations: [required]
    }]
  }

  onSubmit = (formValues) => {
    this.props.onSubmit(formValues)
  }
}

UpdatePassword.propTypes = {
  onSubmit: PropTypes.func.isRequired
}
